/**
*		© Asylum 2017
* 		Community / Social Application Services
**/

import { Injectable, EventEmitter, Output } from '@angular/core';
import { Http, RequestOptions, Response, URLSearchParams, Headers } from '@angular/http';
import { CookieService } from 'ngx-cookie';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { Angulartics2 } from 'angulartics2';
import { UserService } from './user.service';

import { AppComponent } from '../app.component';
import { environment } from '../environment';
import { Account } from '../models/account';
import { NewAccount } from '../models/account';
import { Claim } from '../models/claim';
import { Video } from '../models/video';
import { Post } from '../models/post';
import { Conversation, Message } from '../models/message';
import { Friend } from '../models/friend';
import { Interaction } from '../models/interaction';
import { Notification } from '../models/notification';
import { GameServer } from '../models/server';
import { SocialChannel } from '../models/channel';
import { Reaction } from '../models/reaction';
import { Comment } from '../models/comment';


@Injectable()
export class SocialService { 

	public now: any;
	public token: any;
	public future: any;
	public messageBoxes: any;
	public conversations = [];
	public accounts: EventEmitter<Account> = new EventEmitter<Account>();

	constructor(private http 		 : Http,
				private user		 : UserService,
				private cookie 		 : CookieService,
				private track 		 : Angulartics2) {
				// set token if saved in local storage
				this.token = this.cookie.get('id');

				this.now = new Date();
				this.now.setMinutes(this.now.getMinutes() + 7200);
				
				this.future = new Date();
				this.future.setMinutes(this.future.getMinutes() + 300000);
	}

	
	updateFriend(id, status): Promise<Friend> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('id', id);
		data.append('status', status);

		// Ask the backend to authenticate the user
	   	return this.http.post(`${environment.baseUrl}/friend/update/`, data, options)
		.toPromise()
		.then(mapFriend)
		.catch((err) => { 
			// toss, no user
		});

	}


	friendList(): Promise<Friend> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Ask the backend to authenticate the user
	   	return this.http.get(`${environment.baseUrl}/friend/list/`, options)
		.toPromise()
		.then(mapFriends)
		.catch((err) => { 
			// toss, no user
		});

	}

	friendRequest(friendId): Promise<Friend> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('id', friendId);

		// Ask the backend to authenticate the user
	   	return this.http.post(`${environment.baseUrl}/friend/add/`, data, options)
		.toPromise()
		.then(mapFriend)
		.catch((err) => { 
			// toss, no user
		});

	}

	getRequests(): Promise<Friend> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Ask the backend to authenticate the user
	   	return this.http.get(`${environment.baseUrl}/friend/requests/`, options)
		.toPromise()
		.then(mapFriends)
		.catch((err) => { 
			// toss, no user
		});
	}
	
	getNotifications(): Promise<Notification> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Ask the backend to authenticate the user
	   	return this.http.get(`${environment.baseUrl}/notifications/`, options)
		.toPromise()
		.then(mapNotification)
		.catch((err) => { 
			// toss, no user
		});
	}

	getOpenConversations(): Promise<Conversation> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Get open convos
		let convos = this.cookie.get('conversation');

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('friend', convos);

		// Ask the backend to authenticate the user
	   	return this.http.post(`${environment.baseUrl}/messages/`, data, options)
		.toPromise()
		.then(mapConversation)
		.catch((err) => { 
			// toss, no user
		});
	}

	getConversations(ids?): Promise<Conversation> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Get open convos
		let convos = this.cookie.get('conversation');

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('friend', convos);

		// Ask the backend to authenticate the user
	   	return this.http.post(`${environment.baseUrl}/messages/`, data, options)
		.toPromise()
		.then(mapConversation)
		.catch((err) => { 
			// toss, no user
		});
	}

	newConversation(friendid): Promise<Conversation> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Store it in the cookie
		let convos = this.cookie.get('conversation');
		if (convos) this.conversations = JSON.parse(convos);
		
		if ( this.conversations.indexOf(friendid) == -1 ) {
			this.conversations.push(friendid);
			this.cookie.put('conversation', JSON.stringify( this.conversations ), { expires: this.future });
		}

		let data = new URLSearchParams();
		data.append('friend', friendid);

		// Ask the backend to authenticate the user
	   	return this.http.post(`${environment.baseUrl}/messages/new/`, data, options)
		.toPromise()
		.then(mapConversation)
		.catch((err) => { 
			// toss, no user
		});
	}



	groupFeed(): Observable<any> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/groupfeed/`, options)
		.map((response: Response) => {
			return response.text()
		});

	}

	// Load the activity feed for posts which show up in the sidebar
	activityFeed(): Observable<any> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/activityfeed/`, options)
		.map((response: Response) => {
			return response.text()
		});

	}

	// Load the base interactions available: like, laugh, etc..
	loadInteractions(): Promise<Interaction> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/interactions/`, options)
			.toPromise()
			.then(mapInteractions)
			.catch((err) => { 
				// toss, no user
			});	
	}


	// Load the base interactions available: like, laugh, etc..
	loadSocialChannels(): Promise<SocialChannel> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/channels/`, options)
			.toPromise()
			.then(mapChannels)
			.catch((err) => { 
				// toss, no user
			});	
	}


	// Load the base interactions available: like, laugh, etc..
	loadUsersCharacters(): Promise<SocialChannel> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/characters/`, options)
			.toPromise()
			.then(mapChannels)
			.catch((err) => { 
				// toss, no user
			});	
	}


	// Load the base interactions available: like, laugh, etc..
	joinChannel(id): Promise<SocialChannel> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		let data = new URLSearchParams();
		data.append('channel', id);

		return this.http.post(`${environment.baseUrl}/channels/join/`, data, options)
			.toPromise()
			.then(mapChannels)
			.catch((err) => { 
				// toss, no user
			});	
	}


	// Load the base interactions available: like, laugh, etc..
	leaveChannel(id): Promise<SocialChannel> {

		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		let data = new URLSearchParams();
		data.append('channel', id);

		return this.http.post(`${environment.baseUrl}/channels/leave/`, data, options)
			.toPromise()
			.then(mapChannels)
			.catch((err) => { 
				// toss, no user
			});	
	}


	// Get the profile feed with an optional user
	feed(username?): Promise<Post> {
		// Authorize a user by adding their token into the Headers of our request
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/feed/?user=${username}`, options)
		.toPromise()
		.then(mapPosts)
		.catch((err) => { 
			console.log(err);
			// toss, no user
		});
	}


	// Send a Post
	newPost(body, channel?, receiver?): Promise<Post> {

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('body', body);
		if (channel) data.append('channel', channel);
		if (receiver) data.append('receiver', receiver);

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
	
		// Pass them to purchase endpoint
		return this.http
			.post(`${environment.baseUrl}/post/`, data, { headers: headers })
			.toPromise()
			.then(mapPosts)
			.catch((err) => {
				console.log(err);
			});
	
	}

	removePost(post): Promise<Post> {
		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });

		return this.http.get(`${environment.baseUrl}/post/remove/?post=${post}`, { headers: headers })
			.toPromise()
			.then(mapPosts)
			.catch((err) => {
				console.log(err);
			});
	}


	getPeople(): Promise<Friend> {
		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });

		return this.http.get(`${environment.baseUrl}/users/`, { headers: headers })
			.toPromise()
			.then(mapFriends)
			.catch((err) => {
				console.log(err);
			});

	}

	searchPeople(query?, limit?, offset?): Promise<Friend> {
		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });

		let data = new URLSearchParams();
		data.append('q', query);
		data.append('limit', limit ? limit : 12 );
		data.append('offset', offset ? offset : 0 );

		return this.http
			.post(`${environment.baseUrl}/search/`, data, { headers: headers })
			.toPromise()
			.then(mapFriends)
			.catch((err) => {
				console.log(err);
			});
	}


	// Get the profile feed with an optional user
	getOnlineUsers(): Promise<Friend> { 
		// Authorize a user by adding their token into the Headers of our request
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });

		let data = new URLSearchParams();
		data.append('ping', new Date().toLocaleString());

		return this.http.post(`${environment.baseUrl}/online/`, data, { headers: headers })
		.toPromise()
		.then(mapFriends)
		.catch((err) => { 

			// toss, no user
		});
	}


	say( message, conversationId, to ): Promise<Conversation> {

		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('message', message);
		data.append('messageid', conversationId.messageid);
		data.append('friend', to);

		return this.http.post(`${environment.baseUrl}/messages/say/`, data, options)
			.toPromise()
			.then(mapConversation)
			.catch((err) => { 
				// toss here
			});

	}


	addConversation(conversationId: any) {

		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('messageid', conversationId);

		this.cookie.put('conversations', JSON.stringify( this.messageBoxes ), { expires: this.now });

  		return this.http.post(`${environment.baseUrl}/messages/open/`, data, options)
			.toPromise()
			.then(mapConversation)
			.catch((err) => { 
				// toss here
		});
  	}



  	removeConversation(conversationId: any) {

  		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

  		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('messageid', conversationId);

		this.cookie.remove('conversations');
		this.cookie.put('conversations', JSON.stringify( this.messageBoxes ), { expires: this.now });

  		return this.http.post(`${environment.baseUrl}/messages/close/`, data, options)
			.toPromise()
			.then(mapConversation)
			.catch((err) => { 
				// toss here
		});


  	}


  	reactions(): Promise<Reaction> {

		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(`${environment.baseUrl}/reactions/`, options)
			.toPromise()
			.then(mapReactions)
			.catch((err) => { 
				// toss here
			});

	}


	react( reaction, id ): Promise<Post> {

		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

  		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('post', id);
		data.append('reaction', reaction);

		return this.http.post(`${environment.baseUrl}/post/like/`, data, options)
			.toPromise()
			.then(mapPost)
			.catch((err) => { 
				// toss here
			});

	}


	removeComment( id ): Promise<Comment> {

		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

  		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('comment', id);

		return this.http.post(`${environment.baseUrl}/comment/remove/`, data, options)
			.toPromise()
			.then(mapComment)
			.catch((err) => { 
				// toss here
			});

	}



	reactToComment( reaction, id ): Promise<Comment> {

		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

  		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('comment', id);
		data.append('reaction', reaction);

		return this.http.post(`${environment.baseUrl}/comment/like/`, data, options)
			.toPromise()
			.then(mapComment)
			.catch((err) => { 
				// toss here
			});

	}

	share( id ): Promise<Conversation> {

		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('post', id);

		return this.http.post(`${environment.baseUrl}/post/share/`, data, options)
			.toPromise()
			.then(mapConversation)
			.catch((err) => { 
				// toss here
			});

	}


	newComment( id, comment ): Promise<Comment> {
		
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
		let options = new RequestOptions({ headers: headers });

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('postid', id);
		data.append('body', comment);

		return this.http.post(`${environment.baseUrl}/post/comment/`, data, options)
			.toPromise()
			.then(mapComment)
			.catch((err) => { 
				// toss here
			});

	}


}




/**
* 		Managing Friend Maps
**/

function mapFriend(response:Response): Friend {
	let res = response.json().user.map(toFriend);
	return res;
}
function mapFriends(response:Response): Friend {
	let res = response.json().users.map(toFriend);
	return res;
}

function toFriend(r:any): Friend {
	let Friendly = <Friend>({
		accountid: r.accountid,
		username: r.username,
		forum_username: r.forum_username,
		tagline: r.tagline,
		firstname: r.firstname,
		surname: r.surname,
		profile: r.profile,
		email: r.email,
		image: r.image,
		birthdate: r.birthdate,
		sex: r.sex,
		street: r.street,
		housestring: r.housestring,
		zip: r.zip,
		city: r.city,
		state: r.state,
		countrycode: r.countrycode,
		referrer: r.referrer,
		site_referrer: r.site_referrer,
		created: r.created,
		lastlogin: r.lastlogin,
		role: r.role,
		active: r.active,
		sinceactive: r.sinceactive,
		friend: r.friend
	});
	return Friendly;
}

/**
* 		Notification Mapping
**/

function mapNotification(response:Response): Notification {
	let res = response.json().notification.map(toNotif);
	return res;
}

function mapNotifications(response:Response): Notification {
	let res = response.json().notifications.map(toNotif);
	return res;
}

function toNotif(r:any): Notification {
	let Notif = <Notification>({
		title: r.title,
		description: r.description,
		picture: r.picture,
		link: r.link,
		date: r.date,
	});
	return Notif;
}


/**
* 		Chat Messages
**/

function mapMessage(resp: Response): Message {
	let res = resp.json().message.map(toMessage);
	return res;
}
function mapMessages(resp: Response): Message {
	let res = resp.json().messages.map(toMessage);
	return res;
}
function toMessage(r:any): Message {
	let msg = <Message>({
		body: r.body,
		from: r.from,
		to: r.to,
		time: r.time,
		new: r.new
	});
	return msg;
}

/**
* 		Post Comments
**/

function mapComments(resp: Response): Comment {
	let res = resp.json().comments.map(mapComment);
	return res;
}
function mapComment(resp: Response): Comment {
	let res = resp.json().comments.map(toComment);
	return res;
}
function toComment(r:any): Comment {
	let msg = <Comment>({
		id: r.id,
		author: r.author,
		postid: r.postid,
		body: r.body,
		created: r.created
	});
	return msg;
}

/**
* 		Chat Conversation
**/

function mapConversation(resp: Response): Conversation {
	let res = resp.json().conversation.map(toConversation);
	return res;
}

function toConversation(r:any): Conversation {
	let msg = <Conversation>({
		messageid: r.messageid,
		message: r.message,
		members: r.members,
		new: r.new,
		created: r.created,
		last: r.last
	});
	return msg;
}



/**
* 		Post / Feed Mapping
**/

function mapPost(response:Response): Post {
	let res = response.json().post.map(toPost);
	return res;
}
function mapPosts(response:Response): Post {
	let res = response.json().posts.map(toPost);
	return res;
}

function toPost(r:any): Post {
	let Posts = <Post>({
		time: r.time,
		body: r.body,
		postid: r.postid,
		author: r.author,
		recipient: r.recipient,
		comments: r.comments,
		comments_count: r.comments_count,
		reactions: r.reactions,
		reactionscount: r.reactions_count
	});
	return Posts;
}



/**
* 		Interaction Mapping
**/


function mapInteraction(response:Response): Interaction {
	let res = response.json().interaction.map(toInteraction);
	return res;
}
function mapInteractions(response:Response): Interaction {
	let res = response.json().interactions.map(toInteraction);
	return res;
}

function toInteraction(r:any): Interaction {
	let Interactions = <Interaction>({
		id: r.id,
		name: r.name,
		slug: r.slug,
		plural: r.plural,
		past: r.past,
		future: r.future,
		count: r.count,
		authors: r.authors,
		icon: r.icon,
		time: r.time
	});
	return Interactions;
}


  	
/**
*		Mapping Videos
**/

function mapVideos(response?:Response): Video {
	let res = response.json().videos.map(toVideos);
	return res;
}

function toVideos(r?:any): Video {
	let  vids = <Video>({
		id: r.id,
		vid: r.vid,
		title: r.title,
		description: r.description,
		duration: r.duration,
		links: r.links,
		slug: r.slug,
		tags: r.tags,
		images: r.images,
		views: r.views,
		type: r.type,
		published: r.published,
		order: r.order,
		created: r.created
	});
	return  vids;
}




/**
* 		Gameserver Mapping
**/

function mapServers(response:Response): GameServer {
	let res = response.json().servers.map(toServer);
	return res;
}

function toServer(r:any): GameServer {
	let chart = <GameServer>({
		serverid: r.serverid,
		steamid: r.steamid,
		servername: r.servername,
		players: r.players,
		maxplayers: r.maxplayers,
		gamemode: r.gamemode,
		ipaddr: r.ipaddr,
		region: r.region,
		lat: r.lat,
		lon: r.lon,
		updated: r.updated
	});
	return chart;
}



/**
* 		SocialChannel Mapping
**/

function mapChannels(response:Response): SocialChannel {
	let res = response.json().channels.map(toChan);
	return res;
}

function toChan(r:any): SocialChannel {
	let social = <SocialChannel>({
		id: r.id,
		name: r.name,
		parent: r.parent,
		private: r.private,
		feed: r.feed,
		users: r.users,
		totalusers: r.totalusers,
		online: r.online,
		posts: r.posts
	});
	return social;
}


/**
* 		Reactions Mapping
**/

function mapReactions(response:Response): Reaction {
	let res = response.json().reactions.map(toReactions);
	return res;
}

function toReactions(r:any): Reaction {
	let social = <Reaction>({
		icon: 	 r.icon,
		id: 	 r.id,
		author:	 r.author,
		postid:  r.postid,
		kind: 	 r.kind,
		name: 	 r.name,
		created: r.created
	});
	return social;
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/services/social.service.ts